// extracted by mini-css-extract-plugin
export default {"body":"error_body__l8odr","link":"error_link__SCcIk","menu":"error_menu__UDdAG","container":"error_container__xK6fG","text":"error_text__o7RJe","image":"error_image__GidcD"};